import { render, staticRenderFns } from "./DataTambahBonus.vue?vue&type=template&id=d624c18a&"
import script from "./DataTambahBonus.vue?vue&type=script&lang=js&"
export * from "./DataTambahBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports